import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReportId } from '@core/models';
import { ReportOption } from '../../configuracoes.models';
import { SettingsCardComponent } from '../../components/settings-card/settings-card.component';

@Component({
  selector: 'app-report-selection-tab',
  standalone: true,
  imports: [
    SettingsCardComponent,
  ],
  templateUrl: './report-selection-tab.component.html',
  styleUrl: './report-selection-tab.component.scss',
})
export class ReportSelectionTabComponent {
  @Input({ required: true }) control!: FormControl<ReportId[]>;
  @Input({ required: true }) options: ReportOption[] = [];
  @Input() disabled = false;

  isEnabled(id: ReportId): boolean {
    return this.control.value.includes(id);
  }

  toggle(id: ReportId, enabled: boolean): void {
    if (this.disabled) return;

    const current = this.control.value;
    const next = enabled
      ? [...new Set([...current, id])]
      : current.filter((reportId) => reportId !== id);

    this.control.setValue(next);
    this.control.markAsDirty();
  }
}
